module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/p-insider-1280.e42b351bde35a215.png"+" 1280w",
        images: [{path: "https://static.sniffspot.com/packs/img/p-insider-1280.e42b351bde35a215.png",width: 1280,height: 199}],
        src: "https://static.sniffspot.com/packs/img/p-insider-1280.e42b351bde35a215.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/p-insider-1280.e42b351bde35a215.png"},
        
        width: 1280,
        height: 199
      }